export default "__VITE_ASSET__t79EEjZw__"